// Constants
import { STORAGE_AUTH_TOKEN } from "constants/variables";

// Utils
import { getLocalStorageItem } from "utils/localStorage";

export const getAuthToken = () => ({
  Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
});
